<template>
  <!-- 关联用--普本院校列表 -->
  <!--用于父组件中展示的UI-->
  <el-row>
    <!-- 单选 -->
      <el-button
        :plain="true"
        @click="openDialog"
        class="relevancy_btn"
        :disabled="isEdit"
        ><el-icon><Plus /></el-icon>&nbsp;&nbsp;{{
          selectData.length > 0
            ? "已选择(" + selectData[0].name + ")院校"
            : "点击选择"
        }}</el-button
      >
  </el-row>
  <el-dialog
    :show-close="false"
    v-model="tableDialog"
    :close-on-click-modal="false"
    :fullscreen="false"
    title="选择普本院校"
    width="850px"
    append-to-body
  >
    <div class="table_dialog">
      <el-table
        class="table"
        v-loading="loading"
        ref="multipleTableRef"
        :data="tableData"
        max-height="500px"
        border
        :header-cell-style="{ background: '#f5f7fa' }"
        style="width: 100%; margin-top: -20px"
        :header-cell-class-name="cellClass"
        @select="select"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column
          prop="name"
          label="院校名称"
          min-width="200"
          align="left"
          :show-overflow-tooltip="true"
          inputSearch="true"
        >
          <template #header>
            <el-popover placement="bottom" :width="300" trigger="click">
              <template #reference>
                <div>
                  <span class="search-title">院校名称</span>
                  <el-icon><Search /></el-icon>
                </div>
              </template>
              <el-input
                v-model="nameInput"
                class="m-2"
                placeholder="请输入院校名称搜索"
                size="large"
                clearable
                @clear="getpbSchoolData('search')"
              >
                <template #suffix>
                  <el-icon @click="getpbSchoolData('search')" clearable
                    ><Search
                  /></el-icon>
                </template>
              </el-input>
            </el-popover>
          </template>
          <template #default="scope">
            <el-image
              v-if="/.(png|jpg|jpeg|gif|JPG)$/g.test(scope.row.logoPath)"
              style="width: 20px; height: 20px; border: 1px solid #dcdfe6"
              :src="scope.row.logoPath"
              :preview-src-list="[scope.row.logoPath]"
              fit="cover"
              close-on-press-escape
              hide-on-click-modal
            />
            <span :class="scope.row.name ? '' : 'gray'">{{
              scope.row.name ? scope.row.name : "未设置"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="orderIndex"
          label="排序顺序"
          width="120"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template #default="scope">
            <span :class="scope.row.orderIndex ? '' : 'gray'">{{
              scope.row.orderIndex ? scope.row.orderIndex : "未设置"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="cityAddress"
          label="所属城市"
          width="130"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template #default="scope">
            <span :class="scope.row.cityAddress ? '' : 'gray'">{{
              scope.row.cityAddress ? scope.row.cityAddress : "未设置"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="nature"
          label="院校性质"
          width="130"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template #header>
            <el-popover placement="bottom" :width="200" trigger="click">
              <template #reference>
                <div>
                  <span class="search-title">院校性质</span>
                  <el-icon><ArrowDown /></el-icon>
                </div>
              </template>
              <el-select
                v-model="natureValue"
                class="m-2"
                placeholder="请选择院校性质"
                size="large"
                clearable
                @change="getpbSchoolData('search')"
              >
                <el-option
                  v-for="item in natureList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                />
              </el-select>
            </el-popover>
          </template>
          <template #default="scope">
            <span :class="scope.row.nature ? '' : 'gray'">{{
              scope.row.nature ? scope.row.nature : "未设置"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="types"
          label="院校类别"
          width="130"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template #header>
            <el-popover placement="bottom" :width="200" trigger="click">
              <template #reference>
                <div>
                  <span class="search-title">院校类别</span>
                  <el-icon><ArrowDown /></el-icon>
                </div>
              </template>
              <el-select
                v-model="typeValue"
                class="m-2"
                placeholder="请选择院校类别"
                size="large"
                clearable
                filterable
                @change="getpbSchoolData('search')"
              >
                <el-option
                  v-for="item in typesList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                />
              </el-select>
            </el-popover>
          </template>
          <template #default="scope">
            <span :class="scope.row.types ? '' : 'gray'">{{
              scope.row.types ? scope.row.types : "未设置"
            }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="createTime"
          label="创建时间"
          width="200"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column> -->
      </el-table>
    </div>
    <div class="choose_bom">
      <span style="margin-right: 10px" v-if="selectData.length > 0"
        >已选择[
        <b class="select_red" style="font-size: 16px">{{
          selectData[0].name
        }}</b>
        ]院校</span
      >
      <span style="margin-right: 10px" v-else>请先选择院校</span>
      <div style="font-size: 16px; float: right">
        <el-button @click="closeDialog($event)" size="medium">取消</el-button>
        <el-button size="medium" type="primary" @click="clickTrue($event)" plain
          >确定</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {
  getAllSchoolPtNature,
  getAllSchoolPtTypes,
  getConditionsList,
} from "network/pbSchool.js";
import { reactive, onMounted, watch, toRefs, ref, toRaw, nextTick } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { lostFocus } from "common/utils";
export default {
  name: "PbschoolTable",
  props: {
    isEdit: Boolean,
    schoolId: Number,
  },
  components: {},
  emits: {
    "change-school": null,
  },
  setup(props, { emit }) {

    // 监听props
    watch(
      props,
      (newProps) => {
        //  获取当前编辑对象的 院校id
        const propsData = toRaw(newProps);
        data.schoolId = propsData.schoolId;
        getpbSchoolData(""); //请求普本院校列表数据
      }
      // {
      //     immediate: true,
      //     deep: true
      // }
    );

    const multipleTableRef = ref();

    //这里定义一个结构体，用来保存项目信息
    const data = reactive({
      tableData: [],
      // 表格是否在加载中
      loading: true,
      nameInput: "", //筛选 普本院校名称
      natureValue: "", //筛选 普本院校性质
      natureList: [], //普本院校性质下拉选项
      typeValue: "", //筛选 普本院校类别
      typesList: [], //普本院校类别下拉选项
      tableDialog: false,
      selectData: [], //选中数据
    });

    //挂载后调用函数获取项目数据
    onMounted(() => {
      getNatureData(); //获取院校性质
      getTypesData(); //获取院校类别
    });
    // 去掉全选按钮操作
    const cellClass = (row) => {
      if (row.columnIndex === 0) {
        return "disabledCheck";
      }
    };
    //点击选择 打开表格
    const openDialog = () => {
      if (toRaw(props).schoolId == null) {
        data.tableDialog = true;
        data.schoolId = null;
        getpbSchoolData(""); //请求普本院校列表数据
      } else {
        data.tableDialog = true;
        if (multipleTableRef.value) {
          changeSelRow();
        } else {
          nextTick(() => {
            changeSelRow();
          });
        }
      }
    };
    // 表格初始化选中
    function changeSelRow() {
      for (var i = 0; i < toRaw(data.tableData).length; i++) {
        if (data.schoolId == toRaw(data.tableData)[i].id) {
          multipleTableRef.value.toggleRowSelection(
            toRaw(data.tableData)[i],
            true
          );
          data.selectData.push(toRaw(data.tableData)[i]);
        }
        data.loading = false;
      }
    }
    // 表格单选行处理
    const select = (selection, row) => {
      if (selection.length == 0) {
        data.selectData = [];
      }
      // 清除 所有勾选项
      multipleTableRef.value.clearSelection();
      // 当表格数据都没有被勾选的时候 就返回
      // 主要用于将当前勾选的表格状态清除
      if (selection.length == 0) return;
      multipleTableRef.value.toggleRowSelection(row, true);
      data.selectData = [];
      data.selectData.push(toRaw(row));
    };
    // 取消
    const closeDialog = (e) => {
      lostFocus(e);
      if (data.selectData && data.selectData.length > 0) {
        ElMessageBox.confirm("将取消当前选中院校", "取消", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            data.selectData = [];
            data.tableData.forEach((item) => {
              multipleTableRef.value.toggleRowSelection(item, false);
            });
            data.tableDialog = false;
              emit("change-school",null);
          })
          .catch(() => {});
      } else {
        data.tableDialog = false;
      }
    };
    //确定选中
    const clickTrue = (e) => {
      lostFocus(e);
      if (data.selectData.length > 0) {
        emit("change-school", data.selectData[0]);
        data.tableDialog = false;
      } else {
        ElMessage.warning("请先选择院校");
      }
    };
    function getNatureData() {
      getAllSchoolPtNature()
        .then((res) => {
          if (res.code == 1) {
            data.natureList = res.result;
          } else {
            ElMessage.error(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    function getTypesData() {
      getAllSchoolPtTypes()
        .then((res) => {
          if (res.code == 1) {
            data.typesList = res.result;
          } else {
            ElMessage.error(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    //更新列表 区别于搜索要请求第一页
    const updateList = () => {
      getpbSchoolData("");
    };
    // 获取列表
    const getpbSchoolData = (type) => {
      if (type == "search") {
        data.schoolId = 0;
      }
      data.loading = true;
      const obj = {
        schoolPtSelect: data.schoolId || null,
        name: data.nameInput || null,
        nature: data.natureValue || 0,
        areaId: data.typeValue || 0,
      };
      getConditionsList(obj)
        .then((result) => {
         if (result && result.code == 1) {
            data.loading = false;
            const list = result.result;
            const dataList = toRaw(list);
            // 格式化
            dataList.forEach((item) => {
              if (data.schoolId == item.id) {
                data.selectData.push(item);
              }
              const list = toRaw(data.natureList);
              list.forEach((i) => {
                if (i.key == item.nature) {
                  item.nature = i.value;
                }
              });
              const list2 = toRaw(data.typesList);
              list2.forEach((j) => {
                if (j.key == item.types) {
                  item.types = j.value;
                }
              });
            });
            data.tableData = dataList;
            // 初始化选中
            if (multipleTableRef.value) {
              setTimeout(function () {
                changeSelRow();
              }, 1000);
            }
          } else {
            data.loading = false;
            ElMessage.error(result.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    return {
      //解构Data结构体，让模板可以直接调用Data里面的对象
      ...toRefs(data),
      multipleTableRef,
      cellClass,
      openDialog,
      select,
      closeDialog,
      clickTrue,
      updateList,
      getpbSchoolData,
    };
  },
};
</script>
<style scoped>
.relevancy_btn {
  width:330px;
}
.table_dialog {
  position: relative;
  margin-bottom: 30px;
}
.table_dialog .bottomTool {
  position: absolute;
  bottom: -45px;
  right: 0;
}
.choose_bom {
  margin-top: 20px;
  line-height: 35px;
}
.select_red {
  color: red;
}
/* 深度选择器 去掉全选按钮 */
::v-deep .el-table .disabledCheck .cell .el-checkbox__inner {
  display: none;
}

::v-deep .el-table .disabledCheck .cell::before {
  content: "";
  text-align: center;
}
::v-deep .el-table__row td:first-child {
  /* border-top: var(--el-table-border);
  border-bottom: var(--el-table-border); */
  box-sizing: border-box;
}
</style>

